import type { StateCreator } from 'zustand';

import type { GlobalStore, MiscSlice } from '../schema';

const RETIREE_INSIGHTS_REDIRECT_URL = 'RETIREE_INSIGHTS_REDIRECT_URL';

export const createMiscSlice: StateCreator<
  GlobalStore,
  [['zustand/devtools', never]],
  [],
  MiscSlice
> = (set) => ({
  retireeInsightsRedirectUrl:
    sessionStorage.getItem(RETIREE_INSIGHTS_REDIRECT_URL) ?? '/retirement_insights?limit=20&page=1',
  filterState: null,
  prevPath: '',
  setMiscState: (updates) => {
    if (updates.retireeInsightsRedirectUrl !== undefined) {
      sessionStorage.setItem(RETIREE_INSIGHTS_REDIRECT_URL, updates.retireeInsightsRedirectUrl);
    }
    set(updates as Partial<GlobalStore>, false, 'misc/set');
  },
});
